import { render, staticRenderFns } from "./ContractsAdd.vue?vue&type=template&id=541ca417&"
import script from "./ContractsAdd.vue?vue&type=script&lang=ts&"
export * from "./ContractsAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports